var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var ensureExistence = (scopeName, key) => {
	var scope = __webpack_require__.S[scopeName];
	if(!scope || !__webpack_require__.o(scope, key)) throw new Error("Shared module " + key + " doesn't exist in shared scope " + scopeName);
	return scope;
};
var findVersion = (scope, key) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key) => {
	var versions = scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getSingleton = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	return get(scope[key][version]);
};
var getSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var getStrictSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) throw new Error(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var findValidVersion = (scope, key, requiredVersion) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ") of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var getValidVersion = (scope, scopeName, key, requiredVersion) => {
	var entry = findValidVersion(scope, key, requiredVersion);
	if(entry) return get(entry);
	throw new Error(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var warn = (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var warnInvalidVersion = (scope, scopeName, key, requiredVersion) => {
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var init = (fn) => (function(scopeName, a, b, c) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then) return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], a, b, c));
	return fn(scopeName, __webpack_require__.S[scopeName], a, b, c);
});

var load = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return get(findVersion(scope, key));
});
var loadFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	return scope && __webpack_require__.o(scope, key) ? get(findVersion(scope, key)) : fallback();
});
var loadVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getValidVersion(scope, scopeName, key, version);
});
var loadStrictSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var loadVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	var entry = scope && __webpack_require__.o(scope, key) && findValidVersion(scope, key, version);
	return entry ? get(entry) : fallback();
});
var loadStrictSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var installedModules = {};
var moduleToHandlerMapping = {
	82967: () => (loadSingletonVersionCheckFallback("default", "@azure/communication-common", [1,2,3,1], () => (Promise.all([__webpack_require__.e(7541), __webpack_require__.e(8035)]).then(() => (() => (__webpack_require__(68144))))))),
	98283: () => (loadSingletonVersionCheckFallback("default", "react", [4,18,3,1], () => (__webpack_require__.e(2483).then(() => (() => (__webpack_require__(82483))))))),
	89205: () => (loadSingletonVersionCheckFallback("default", "react-dom", [4,18,3,1], () => (__webpack_require__.e(9998).then(() => (() => (__webpack_require__(99998))))))),
	40338: () => (loadSingletonVersionCheckFallback("default", "reselect", [1,4,1,5], () => (__webpack_require__.e(8897).then(() => (() => (__webpack_require__(78897))))))),
	49743: () => (loadSingletonVersionCheckFallback("default", "@azure/communication-calling-effects", [1,1,1,3], () => (__webpack_require__.e(6445).then(() => (() => (__webpack_require__(86445))))))),
	71848: () => (loadSingletonVersionCheckFallback("default", "@azure/communication-calling", [1,1,33,3], () => (__webpack_require__.e(1360).then(() => (() => (__webpack_require__(31360))))))),
	58887: () => (loadSingletonVersionCheckFallback("default", "@azure/communication-chat", [1,1,5,4], () => (Promise.all([__webpack_require__.e(2983), __webpack_require__.e(7541), __webpack_require__.e(1960)]).then(() => (() => (__webpack_require__(41960))))))),
	12143: () => (loadSingletonVersionCheckFallback("default", "@azure/msal-browser", [4,2,37,0], () => (__webpack_require__.e(1610).then(() => (() => (__webpack_require__(41610))))))),
	77482: () => (loadSingletonVersionCheckFallback("default", "@emotion/react", [4,11,13,3], () => (Promise.all([__webpack_require__.e(6243), __webpack_require__.e(3177)]).then(() => (() => (__webpack_require__(3177))))))),
	98738: () => (loadSingletonVersionCheckFallback("default", "@mui/system", [4,5,16,7], () => (Promise.all([__webpack_require__.e(8069), __webpack_require__.e(6643)]).then(() => (() => (__webpack_require__(56942))))))),
	6737: () => (loadSingletonVersionCheckFallback("default", "@mui/styled-engine", [4,5,16,6], () => (Promise.all([__webpack_require__.e(6243), __webpack_require__.e(2244), __webpack_require__.e(2779), __webpack_require__.e(4886)]).then(() => (() => (__webpack_require__(52505))))))),
	13930: () => (loadSingletonVersionCheckFallback("default", "@mui/system", [4,5,16,7], () => (Promise.all([__webpack_require__.e(3229), __webpack_require__.e(8937)]).then(() => (() => (__webpack_require__(13229))))))),
	2779: () => (loadSingletonVersionCheckFallback("default", "@emotion/styled", [4,11,13,0], () => (Promise.all([__webpack_require__.e(5912), __webpack_require__.e(2058)]).then(() => (() => (__webpack_require__(72784))))))),
	75033: () => (loadSingletonVersionCheckFallback("default", "@mui/styled-engine", [4,5,16,6], () => (Promise.all([__webpack_require__.e(6243), __webpack_require__.e(2244), __webpack_require__.e(2779), __webpack_require__.e(5101)]).then(() => (() => (__webpack_require__(35101))))))),
	28937: () => (loadSingletonVersionCheckFallback("default", "@mui/styled-engine", [4,5,16,6], () => (Promise.all([__webpack_require__.e(6243), __webpack_require__.e(2244), __webpack_require__.e(2779), __webpack_require__.e(8728)]).then(() => (() => (__webpack_require__(66347))))))),
	67687: () => (loadSingletonVersionCheckFallback("default", "redux", [1,4,1,2], () => (__webpack_require__.e(8714).then(() => (() => (__webpack_require__(18714))))))),
	13050: () => (loadSingletonVersionCheckFallback("default", "@azure/msal-react", [4,1,5,7], () => (Promise.all([__webpack_require__.e(2540), __webpack_require__.e(8283), __webpack_require__.e(2143)]).then(() => (() => (__webpack_require__(52540))))))),
	32783: () => (loadSingletonVersionCheckFallback("default", "react-router-dom", [4,6,28,0], () => (Promise.all([__webpack_require__.e(7868), __webpack_require__.e(9205)]).then(() => (() => (__webpack_require__(37868))))))),
	8123: () => (loadSingletonVersionCheckFallback("default", "@mui/system", [4,5,16,7], () => (Promise.all([__webpack_require__.e(7603), __webpack_require__.e(5033)]).then(() => (() => (__webpack_require__(47603))))))),
	21159: () => (loadSingletonVersionCheckFallback("default", "framer-motion", [4,11,11,8], () => (__webpack_require__.e(5315).then(() => (() => (__webpack_require__(15315))))))),
	23050: () => (loadSingletonVersionCheckFallback("default", "@stg-oneportal/axs-frontend-helpers", [4,3,1,5], () => (Promise.all([__webpack_require__.e(2760), __webpack_require__.e(2464), __webpack_require__.e(3050), __webpack_require__.e(812), __webpack_require__.e(4073), __webpack_require__.e(3608)]).then(() => (() => (__webpack_require__(42464))))))),
	57880: () => (loadSingletonVersionCheckFallback("default", "@emotion/react", [4,11,13,3], () => (Promise.all([__webpack_require__.e(6243), __webpack_require__.e(187)]).then(() => (() => (__webpack_require__(45425))))))),
	67728: () => (loadSingletonVersionCheckFallback("default", "react-pdf", [1,9,2,1], () => (__webpack_require__.e(8653).then(() => (() => (__webpack_require__(28653))))))),
	78466: () => (loadSingletonVersionCheckFallback("default", "notistack", [1,2,0,5], () => (__webpack_require__.e(934).then(() => (() => (__webpack_require__(98553))))))),
	76341: () => (loadSingletonVersionCheckFallback("default", "dayjs", [4,1,11,5], () => (__webpack_require__.e(4686).then(() => (() => (__webpack_require__(54686))))))),
	3200: () => (loadSingletonVersionCheckFallback("default", "react-i18next", [4,15,1,1], () => (__webpack_require__.e(7958).then(() => (() => (__webpack_require__(7958))))))),
	43365: () => (loadSingletonVersionCheckFallback("default", "i18next", [4,23,16,5], () => (__webpack_require__.e(5032).then(() => (() => (__webpack_require__(95032))))))),
	11963: () => (loadSingletonVersionCheckFallback("default", "lodash-es", [1,4,17,21], () => (__webpack_require__.e(7003).then(() => (() => (__webpack_require__(77003))))))),
	54587: () => (loadSingletonVersionCheckFallback("default", "axios", [1,1,12,2], () => (__webpack_require__.e(4183).then(() => (() => (__webpack_require__(64183))))))),
	73608: () => (loadSingletonVersionCheckFallback("default", "query-string", [1,7,1,3], () => (__webpack_require__.e(2682).then(() => (() => (__webpack_require__(82682))))))),
	7283: () => (loadSingletonVersionCheckFallback("default", "query-string", [1,7,1,3], () => (__webpack_require__.e(2369).then(() => (() => (__webpack_require__(72369))))))),
	28132: () => (loadSingletonVersionCheckFallback("default", "@azure/communication-react", [1,1,24,0], () => (Promise.all([__webpack_require__.e(2983), __webpack_require__.e(4624), __webpack_require__.e(9205), __webpack_require__.e(338), __webpack_require__.e(6302)]).then(() => (() => (__webpack_require__(54624))))))),
	51159: () => (loadSingletonVersionCheckFallback("default", "@mui/material", [4,5,16,7], () => (Promise.all([__webpack_require__.e(2936), __webpack_require__.e(5402), __webpack_require__.e(6768), __webpack_require__.e(627), __webpack_require__.e(8069), __webpack_require__.e(3679), __webpack_require__.e(9205), __webpack_require__.e(8738)]).then(() => (() => (__webpack_require__(3679))))))),
	53431: () => (loadSingletonVersionCheckFallback("default", "react-redux", [1,8,0,5], () => (Promise.all([__webpack_require__.e(7647), __webpack_require__.e(9205)]).then(() => (() => (__webpack_require__(47647))))))),
	57497: () => (loadSingletonVersionCheckFallback("default", "@mui/lab", [7,5,0,0,,"alpha",94], () => (Promise.all([__webpack_require__.e(2936), __webpack_require__.e(5402), __webpack_require__.e(627), __webpack_require__.e(5521), __webpack_require__.e(9205), __webpack_require__.e(8738), __webpack_require__.e(3930)]).then(() => (() => (__webpack_require__(87902))))))),
	70696: () => (loadSingletonVersionCheckFallback("default", "@stg-oneportal/axs-frontend-helpers", [4,3,1,5], () => (Promise.all([__webpack_require__.e(2760), __webpack_require__.e(6950), __webpack_require__.e(2783), __webpack_require__.e(3050), __webpack_require__.e(4073), __webpack_require__.e(7283)]).then(() => (() => (__webpack_require__(66950))))))),
	72906: () => (loadSingletonVersionCheckFallback("default", "history", [1,4,9,0], () => (__webpack_require__.e(949).then(() => (() => (__webpack_require__(50949))))))),
	87908: () => (loadSingletonVersionCheckFallback("default", "i18next-browser-languagedetector", [4,8,0,0], () => (__webpack_require__.e(710).then(() => (() => (__webpack_require__(90710))))))),
	88413: () => (loadSingletonVersionCheckFallback("default", "@stg-oneportal/axs-auth-library", [4,3,5,0], () => (Promise.all([__webpack_require__.e(3050), __webpack_require__.e(3294)]).then(() => (() => (__webpack_require__(93294))))))),
	97941: () => (loadSingletonVersionCheckFallback("default", "@stg-oneportal/axs-component-library", [4,3,50,0], () => (Promise.all([__webpack_require__.e(2936), __webpack_require__.e(5402), __webpack_require__.e(6768), __webpack_require__.e(3319), __webpack_require__.e(9205), __webpack_require__.e(8738), __webpack_require__.e(2783), __webpack_require__.e(9975), __webpack_require__.e(5847)]).then(() => (() => (__webpack_require__(73319))))))),
	99573: () => (loadSingletonVersionCheckFallback("default", "@reduxjs/toolkit", [1,1,7,1], () => (Promise.all([__webpack_require__.e(4365), __webpack_require__.e(338)]).then(() => (() => (__webpack_require__(24365)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"338": [
		40338
	],
	"812": [
		3200,
		43365
	],
	"2143": [
		12143
	],
	"2244": [
		77482
	],
	"2779": [
		2779
	],
	"2783": [
		32783
	],
	"2967": [
		82967
	],
	"3050": [
		13050
	],
	"3608": [
		73608
	],
	"3930": [
		13930
	],
	"4073": [
		11963,
		54587
	],
	"5033": [
		75033
	],
	"6302": [
		49743,
		71848
	],
	"6341": [
		76341
	],
	"6737": [
		6737
	],
	"7283": [
		7283
	],
	"7614": [
		28132,
		51159,
		53431,
		57497,
		70696,
		72906,
		87908,
		88413,
		97941,
		99573
	],
	"7687": [
		67687
	],
	"8283": [
		98283
	],
	"8738": [
		98738
	],
	"8887": [
		58887
	],
	"8937": [
		28937
	],
	"9205": [
		89205
	],
	"9975": [
		8123,
		21159,
		23050,
		57880,
		67728,
		78466
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}